/**
 * Before/After スライダー
 * 1. 施工前の画像が表示
 * 2. 施工後の画像がフェードインで重なる
 * 3. フェードイン後、スライダーで調整可能に
 */

const initBeforeAfter = () => {
  const containers = document.querySelectorAll('.js-before-after');

  containers.forEach((container) => {
    const afterImage = container.querySelector('.c-main-visual__image-after');
    const slider = container.querySelector('.c-main-visual__image-slider');

    if (!afterImage || !slider) return;

    let isDragging = false;
    let isSliderEnabled = false;

    // 画面幅に応じた最大値を取得
    const getMaxPercent = () => {
      const width = window.innerWidth;
      if (width <= 767) return 90; // スマホ
      if (width <= 1024) return 85; // タブレット
      if (width <= 1285) return 75;
      if (width <= 1450) return 80;
      return 85;
    };

    // スライダー位置を更新（leftプロパティとclip-pathで制御）
    const setSliderPosition = (percent) => {
      const maxPercent = getMaxPercent();
      // 5%〜maxPercent%の範囲に制限
      percent = Math.max(5, Math.min(maxPercent, percent));

      // clip-pathは右端からのパーセントで指定
      afterImage.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
      slider.style.left = `${percent}%`;
    };

    // クリック/ドラッグ位置からスライダー位置を計算
    const updateSliderPosition = (clientX) => {
      if (!isSliderEnabled) return;

      const rect = container.getBoundingClientRect();
      const percent = ((clientX - rect.left) / rect.width) * 100;
      setSliderPosition(percent);
    };

    // マウスイベント
    slider.addEventListener('mousedown', (e) => {
      if (!isSliderEnabled) return;
      isDragging = true;
      e.preventDefault();
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      updateSliderPosition(e.clientX);
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
    });

    // タッチイベント
    slider.addEventListener('touchstart', (e) => {
      if (!isSliderEnabled) return;
      isDragging = true;
    });

    document.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const touch = e.touches[0];
      updateSliderPosition(touch.clientX);
    });

    document.addEventListener('touchend', () => {
      isDragging = false;
    });

    // コンテナ全体でのクリック/タップでも位置変更可能に
    container.addEventListener('click', (e) => {
      if (!isSliderEnabled) return;
      if (e.target.closest('.c-main-visual__image-slider')) return;
      updateSliderPosition(e.clientX);
    });

    // フェードインアニメーション
    const runFadeIn = () => {
      const fadeInDelay = 1000; // 1秒後に開始
      const fadeInDuration = 1500; // 1.5秒かけてフェードイン
      let startTime = null;

      const animate = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / fadeInDuration, 1);

        // easeOutCubic
        const eased = 1 - Math.pow(1 - progress, 3);
        afterImage.style.opacity = eased;

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          // フェードイン完了後、スライダーを表示
          showSlider();
        }
      };

      setTimeout(() => {
        requestAnimationFrame(animate);
      }, fadeInDelay);
    };

    // スライダーを表示して操作可能に（バウンスアニメーション付き）
    const showSlider = () => {
      slider.style.opacity = '1';
      slider.style.pointerEvents = 'auto';
      isSliderEnabled = true;

      const maxPercent = getMaxPercent();
      const bounceTarget = maxPercent - 15; // 左に15%バウンス
      const duration = 600; // バウンス時間
      let startTime = null;

      // easeOutBack（オーバーシュート効果）
      const easeOutBack = (t) => {
        const c1 = 1.70158;
        const c3 = c1 + 1;
        return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
      };

      const animate = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // 最大位置からバウンスターゲットへ、その後戻る
        const eased = easeOutBack(progress);
        const currentPos = maxPercent - (maxPercent - bounceTarget) * (1 - eased);

        setSliderPosition(currentPos);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setSliderPosition(maxPercent);
        }
      };

      setSliderPosition(maxPercent);
      requestAnimationFrame(animate);
    };

    // 初期化
    afterImage.style.opacity = '0';
    afterImage.style.clipPath = 'inset(0 0 0 0)'; // 全面表示
    runFadeIn();
  });
};

// DOMContentLoaded で初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBeforeAfter);
} else {
  initBeforeAfter();
}

export default initBeforeAfter;

